import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    standalone: false
})
export class UserAvatarComponent implements OnInit {

  @Input() fullName: string = "";
  @Input() avatar: string = "";
  @Input() firstName: string = "";
  @Input() lastName: string = "";
  @Input() isAdmin: boolean = false;
  @Input() size: string = "medium"; //posible sizes: tiny, small, medium, mediumlarge, large, extralarge
  initials: string = String();

  constructor() { }

  ngOnInit() {
    if( !this.firstName && !this.lastName ) {
      this.getInitials(this.fullName);
    } else {
      if( this.firstName ) {
        this.initials += this.firstName.charAt( 0 ).toUpperCase();
      }
      if( this.lastName ) {
        this.initials += this.lastName.charAt( 0 ).toUpperCase();
      }
    }
  }

  getInitials(name:string) {
    if(name){
      let names = name.split(" ");
      names.forEach(name => {
        this.initials += name.charAt(0).toUpperCase();
      });
    }
  }

}
